import { IPermissionMatrix } from '@directives/has-permissions/permission-matrix/index';
import { UserRole } from '@models/enums/user-role.enum';

export type sitemapAdminPermissionType = 'sitemap_admin_view';

export const sitemapAdminPermissionMatrix: IPermissionMatrix<sitemapAdminPermissionType> = {
  sitemap_admin_view: [UserRole.admin]
};
